export default "__VITE_ASSET__a9eb0fba__"